<template>
	<div>
		<div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-4" v-if="isTeacher">
					<div class="form-group">
						<label>{{ $t("student") }}</label>
						<input
							type="text"
							v-model="search.student_displayname"
							class="form-control"
							@click="selectStudent"
							@keyup.enter="selectStudent"
							:aria-label="$t('student')"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group" v-if="!isTeacher || $UserSession.hasPriv.call(this, 'APP_ALLTEACHERS')">
						<label>{{ $t("teacher") }}</label>
						<input
							type="text"
							v-model="search.teacher_displayname"
							class="form-control"
							@click="selectTeacher"
							@keyup.enter="selectTeacher"
							:aria-label="$t('teacher')"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<SelectInput
						v-model="search.clinicId"
						@input="updateSearch()"
						:label="$t('clinic')"
						:options="$config.getValue('clinics')"
						optionValue="id"
						optionLabel="name"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
			</div>
			<div class="row" v-if="isTeacher">
				<div class="col-md-4">
					<SelectInput
						v-model="search.programme"
						@input="updateSearch()"
						:label="$t('programme')"
						:options="$config.getValue('programmes')"
						optionLabel="Name"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="search.year" @change="updateSearch()" :aria-label="$t('year')">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="search.programme">
								<option
								v-for="year in parseInt(search.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(search.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<SelectInput
						v-model="search.group"
						@input="updateSearch()"
						:label="$t('group')"
						:options="$config.getValue('groups')"
						:indexIsValue="true"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<SelectInput
						v-model="search.locked"
						@input="updateSearch()"
						:label="$t('locked')"
						:options="{'true': $t('locked'), 'false': $t('unlocked')}"
						:indexIsValue="true"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
				<div class="col-md-3">
					<SelectInput
						v-model="search.reflection"
						@input="updateSearch()"
						:label="$t('reflection')"
						:options="{'true': $t('yes'), 'false': $t('no')}"
						:indexIsValue="true"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
				<div class="col-md-3">
					<SelectInput
						v-model="search.specialtyId"
						@input="updateSearch()"
						:label="$t('specialty')"
						:options="$config.getValue('specialties')"
						optionValue="id"
						optionLabel="name"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
				<div class="col-md-3">
					<SelectInput
						v-model="search.typeId"
						@input="updateSearch()"
						:label="$t('session-type')"
						:options="$config.getValue('participationTypes')"
						optionValue="id"
						optionLabel="name"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-7">
				<div class="input-group mb-3">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
						<button
							class="btn btn-outline-primary"
							v-on:click="toggleAdvancedSearch()"
						>
							{{ $t("advanced") }}
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-5">
				<button class="btn btn-secondary btn-lg float-right mb-2 ml-2" @click="getTreatmentSessions"><b-icon icon="arrow-clockwise"></b-icon></button>
				<router-link
					class="btn btn-primary btn-lg mb-3 float-right"
					to="/clinical/treatmentsession"
					>{{ $t("new-session") }}</router-link
				>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="TreatmentSession"
			:dataUrl="`${$settings.APIBaseURL}/treatmentsessions/list`"
			dataProperty="treatmentsessions"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectTreatmentSession"
			ref="infinitescroll"
			containerCyId="treatment-session-list"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll,
	},
	data() {
		return {
			showadvancedsearch: false,
			search: {
				q: "",
				locked: null,
				reflection: null,
				student: null,
				student_displayname: "",
				teacher: null,
				teacher_displayname: "",
				programme: null,
				year: null,
				group: null,
				specialtyId: null,
				typeId: null,
				clinicId: null,
			},
			formsettings: {
				clinics: [],
				specialties: [],
			}
		};
	},
	mounted() {
		this.getFormSettings();
		this.setSearchDefaults();
		this.tryGetSavedSearch();
		this.getTreatmentSessions();
	},
	methods: {
		getFormSettings() {
			var promise = this.$cfetch(`${this.$settings.APIBaseURL}/getclinicalsettings`, {
				cache: true,
				method: "post",
			})
				.then((json) => {
					if (json.status === "SUCCESS") {
						this.$log.info.call(this, "Form settings loaded");
						this.formsettings = json;
					} else {
						this.$log.error.call(this, "Could not fetch form settings");
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
			return promise;
		},
		tryGetSavedSearch(){
			var savedsearch = localStorage.getItem('cafs_ts_savedsearch');
			var data = JSON.parse(savedsearch);
			if(data){
				for(var key in data){
					this.search[key] = data[key];
				};
				this.showadvancedsearch = true;
			}
		},
		newSearch() {
			this.getTreatmentSessions();
		},
		setSearchDefaults(){
			this.search = {
				q: "",
				locked: null,
				reflection: null,
				student: null,
				student_displayname: "All",
				teacher: null,
				teacher_displayname: "All",
				programme: null,
				year: null,
				group: null,
				specialtyId: null,
				typeId: null,
				clinicId: null
			};
			if (this.isTeacher) {
				this.search.teacher = this.$UserSession.getValue("id");
				this.search.teacher_displayname = this.$UserSession.getValue("displayName");
				this.search.locked = "false";
			}
		},
		toggleAdvancedSearch(){
			if(this.showadvancedsearch){
				localStorage.removeItem('cafs_ts_savedsearch');
				this.setSearchDefaults();
				this.showadvancedsearch = false;
				this.getTreatmentSessions();
			} else {
				this.showadvancedsearch = true;
			}
		},
		updateSearch() {
			var body = JSON.parse(JSON.stringify(this.search));
			body.q = null;
			localStorage.setItem('cafs_ts_savedsearch', JSON.stringify(body));
			this.getTreatmentSessions();
		},
		getTreatmentSessions() {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					studentId: this.search.student ? this.search.student : "",
					teacherId: this.search.teacher ? this.search.teacher : "",
					programme: this.search.programme ? this.search.programme.Id : "",
					year: this.search.year ? this.search.year : "",
					group: this.search.group ? this.search.group : "",
					isLocked: this.search.locked ? this.search.locked : "",
					reflection: this.search.reflection ? this.search.reflection : "",
					clinicId: this.search.clinicId ? this.search.clinicId : "",
					typeId: this.search.typeId ? this.search.typeId : "",
					specialtyId: this.search.specialtyId ? this.search.specialtyId : "",
				};
			}
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectTreatmentSession(treatmentsession) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/clinical/treatmentsession/${treatmentsession.id}`);
		},
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						if (self.search.student == selection.id) {
							self.search.student_displayname = "";
							self.search.student = null;
						} else {
							self.search.student_displayname = selection.displayName;
							self.search.student = selection.id;
						}
						self.$store.commit("closeModal");
						self.updateSearch();
					},
					selected: [
						{
							id: this.search.student,
						},
					],
					data: [{
						"id": null ,
						"displayName": this.$t('all')
					}].concat(students),
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true
				});
			});
		},
		selectTeacher() {
  			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				const processedTeachers = teachers.map((teacher) => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)"); 
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function (selection) {
					if (self.search.teacher === selection.id) {
					self.search.teacher_displayname = "";
					self.search.teacher = null;
					} else {
					self.search.teacher_displayname = selection.displayName;
					self.search.teacher = selection.id;
					}
					self.$store.commit("closeModal");
					self.updateSearch();
				},
				selected: [
					{
					id: this.search.teacher,
					},
				],
				data: [{
					id: null,
					displayName: this.$t("all")
					}].concat(processedTeachers),
				captionKey: "displayName",
				subcaptionKey: "subcaption"  
				});
			});
		},

	},
	computed: {
		isTeacher: function () {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
	},
};
</script>
